import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  NavController,
  PopoverController,
  LoadingController,
} from "ionic-angular";
import { Subscription } from "rxjs";
import * as moment from "moment";

import { AuthProvider } from "../../providers/auth/auth";
import { JobsProvider } from "../../providers/jobs/jobs";
import { TrainingCardsProvider } from "../../providers/training/training";

import { JobInfoComponent } from "./../../shared/jobs/job-info";
import { TrainingCardInfoComponent } from "./../../shared/training/training-card-info";

import { IJob, IJobStaff } from "../../interfaces/jobs";
import { ITrainingCard, ITrainingCardStaff, TrainingCardApplicationStatus, TrainingCardStatus } from "../../interfaces/training-cards";
import { IUser } from "../../interfaces/users";


@Component({
  selector: "page-home",
  templateUrl: "home.html",
})
export class HomePage implements OnInit, OnDestroy {
  title = "Dashboard";
  fbUser: any;
  currentUser: any;
  currentUserSubscription: Subscription;
  userDataLoaded = false;

  openJobs: Array<IJob> = [];
  openJobsSubscription: Subscription;
  openJobsDataLoaded = false;

  trainingCards: Array<ITrainingCard> = [];
  trainingCardsSubscription: Subscription;
  trainingCardsDataLoaded = false;

  userTrainingCards: Array<ITrainingCardStaff>;
  userTrainingCardsSubscription: Subscription;
  userTrainingCardsDataLoaded = false;

  loader;

  get trainingCardStatus() {
    return TrainingCardStatus;
  }

  get trainingCardApplicationStatus() {
    return TrainingCardApplicationStatus;
  }

  constructor(
    public navCtrl: NavController,
    public popoverCtrl: PopoverController,
    public loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private jobsProvider: JobsProvider,
    private trainingCardProvider: TrainingCardsProvider,
  ) {}

  ngOnInit() {
    this.loader = this.loadingCtrl.create({
      content: "Loading jobs...",
    });
    this.loader.present();

    this.authProvider.getFbUser().then((fbUser) => {
      console.log(fbUser);
      if (fbUser) {
        this.currentUserSubscription = this.authProvider
          .getUserByUid(fbUser.uid)
          .subscribe(
            (data) => {
              console.log(data);
              this.currentUser = data;

              if (this.currentUser.regType === "recruiter") {
                // TODO: Load recruiter items in dashboard
                this.loadRecruiterJobs();
              } else {
                // TODO: Load staff items in dashboard
                this.loadOpenJobs();
                this.loadTrainingCards();
              }

              this.userDataLoaded = true;
              return data;
            },
            (err) => {
              console.log(err);
            }
          );
      }
    });
  }

  ngOnDestroy() {
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
    if (this.openJobsSubscription) {
      this.openJobsSubscription.unsubscribe();
    }
  }

  ionViewWillLeave() {
    console.log("inside ionViewWillLeave - Home");
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
    if (this.openJobsSubscription) {
      this.openJobsSubscription.unsubscribe();
    }
    this.openJobs = [];
    this.loader.dismiss();
  }

  loadOpenJobs() {
    this.openJobsSubscription = this.jobsProvider.getOpenJobs().subscribe(
      (result) => {
        console.log(result);
        const now = moment().format();
        console.log(now);
        this.openJobs = [];
        result.forEach((job) => {
          if (job.start > now) {
            console.log("job starts in the future");
            this.openJobs.push(job);
          }
        });
        this.openJobsDataLoaded = true;
        setTimeout(() => {
          this.loader.dismiss();
        }, 100);
        return result;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  loadTrainingCards() {
    this.trainingCardsSubscription = this.trainingCardProvider.getTrainingCards(this.currentUser.province).subscribe(
      data => {
        this.trainingCards = [];
        this.trainingCards = data;
        console.log(this.trainingCards);
        this.userTrainingCardsSubscription = this.trainingCardProvider.getUserTrainingCards(this.currentUser.uid).subscribe(
          uData => {
            this.trainingCards.forEach(trainingCard => {
              if (uData.find(ua => ua.trainingCardId === trainingCard.id)) {
                trainingCard.userHasApplied = true;
                trainingCard.userApplicationStatus = uData.find(ua => ua.trainingCardId === trainingCard.id).status
              }
            });
            this.trainingCardsDataLoaded = true;
            return uData;
          },
          err => {
            console.log(err);
          }
        )

        return data;
      },
      err=> {
        console.log(err);
      }
    )
  }

  loadRecruiterJobs() {
    this.openJobsSubscription = this.jobsProvider
      .getRecruiterJobs(this.currentUser.uid)
      .subscribe(
        (result) => {
          console.log(result);
          // const now = moment().format();
          // console.log(now);
          this.openJobs = [];
          result.forEach((job) => {
            // if (job.start > now) {
            console.log("job starts in the future");
            this.openJobs.push(job);
            // }
          });
          setTimeout(() => {
            this.loader.dismiss();
          }, 100);
          this.openJobsDataLoaded = true;
          return result;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  openJob(job: IJob) {
    console.log(job);
    let popover = this.popoverCtrl.create(
      JobInfoComponent,
      { job: job, user: this.currentUser },
      {
        showBackdrop: true,
        enableBackdropDismiss: false,
        cssClass: "job-popover",
      }
    );
    popover.present({
      ev: job,
    });
  }

  openTrainingCard(trainingCard: ITrainingCard) {
    console.log(trainingCard);

    let popover = this.popoverCtrl.create(
      TrainingCardInfoComponent,
      { trainingCard: trainingCard, user: this.currentUser },
      {
        showBackdrop: true,
        enableBackdropDismiss: false,
        cssClass: "training-card-popover",
      }
    );
    popover.present({
      ev: trainingCard,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts